/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetAocsVariablesDTO = Types.Exact<{
  filter?: Types.Maybe<Types.AocFilterDTO>;
}>;


export type GetAocsDTO = (
  { __typename?: 'Query' }
  & { aocs: Array<(
    { __typename?: 'Aoc' }
    & Pick<Types.AocDTO, 'id' | 'name'>
  )> }
);


export const GetAocsDocumentDTO = gql`
    query getAocs($filter: AocFilter) {
  aocs(filter: $filter, sort: [{field: "name", order: ASC}]) {
    id
    name
  }
}
    `;

/**
 * __useGetAocs__
 *
 * To run a query within a React component, call `useGetAocs` and pass it any options that fit your needs.
 * When your component renders, `useGetAocs` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAocs({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAocs(baseOptions?: Apollo.QueryHookOptions<GetAocsDTO, GetAocsVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAocsDTO, GetAocsVariablesDTO>(GetAocsDocumentDTO, options);
      }
export function useGetAocsLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetAocsDTO, GetAocsVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAocsDTO, GetAocsVariablesDTO>(GetAocsDocumentDTO, options);
        }
export type GetAocsHookResult = ReturnType<typeof useGetAocs>;
export type GetAocsLazyQueryDTOHookResult = ReturnType<typeof useGetAocsLazyQueryDTO>;
export type GetAocsQueryResultDTO = Apollo.QueryResult<GetAocsDTO, GetAocsVariablesDTO>;